var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('no-results',{attrs:{"cta":{
    label: _vm.$t(("" + _vm.buttonLabel)),
    class: ("is-outlined" + (_vm.isLoading ? ' is-loading' : ''))
  },"message":_vm.$t(_vm.message),"title":_vm.$t(_vm.title),"icon":"exclamation-circle"},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }